import { JSONArray } from '../types';
import {
  prepareDataForApolloCache,
  QueryInfo,
} from '../prepareDataForApolloCache';
import { featureFlagClient } from '@trello/feature-flag-client';

export const templateCategoriesResolver = async (
  _parent: unknown,
  _args: unknown,
  _context: unknown,
  info: QueryInfo,
) => {
  let model = null;

  const apiUrl = '/1/resources/templates/categories';

  try {
    // Because we are having a splashy marketing launch we want to have a backup
    // Lazy loading in failsaife so that it doesn't impact bundle size
    // TODO: WLRS-794 remove ./templateFailsafe and feature flag
    if (featureFlagClient.get('templates.gallery-failsafe', false)) {
      const failsafeModel = await import(
        /* webpackChunkName: "template-failsafe" */ './templateFailsafe'
      );
      return failsafeModel.categories
        ? prepareDataForApolloCache(failsafeModel.categories as JSONArray, info)
        : failsafeModel.categories;
    }
    const response = await fetch(apiUrl, {
      credentials: 'include',
    });

    if (response.ok) {
      model = await response.json();
    } else {
      if (response.status === 404) {
        model = null;
      } else {
        throw new Error(
          `An error occurred while resolving a GraphQL query. (status: ${response.status}, statusText: ${response.statusText})`,
        );
      }
    }

    return model ? prepareDataForApolloCache(model, info) : model;
  } catch (err) {
    console.error(err);
    return model;
  }
};

export const templateGalleryResolver = async (
  _parent: unknown,
  _args: unknown,
  _context: unknown,
  info: QueryInfo,
) => {
  let model = null;

  const apiUrl = '/1/boards/templates/gallery';

  try {
    // Because we are having a splashy marketing launch we want to have a backup
    // Lazy loading in failsaife so that it doesn't impact bundle size
    // TODO: WLRS-794 remove ./templateFailsafe and feature flag
    if (featureFlagClient.get('templates.gallery-failsafe', false)) {
      const failsafeModel = await import(
        /* webpackChunkName: "template-failsafe" */ './templateFailsafe'
      );
      return failsafeModel.gallery
        ? prepareDataForApolloCache(failsafeModel.gallery as JSONArray, info)
        : failsafeModel.gallery;
    }

    const response = await fetch(apiUrl, {
      credentials: 'include',
    });

    if (response.ok) {
      model = await response.json();
    } else {
      if (response.status === 404) {
        model = null;
      } else {
        throw new Error(
          `An error occurred while resolving a GraphQL query. (status: ${response.status}, statusText: ${response.statusText})`,
        );
      }
    }

    return model ? prepareDataForApolloCache(model, info) : model;
  } catch (err) {
    console.error(err);
    return model;
  }
};
